import { render, staticRenderFns } from "./BirthDatesInput.vue?vue&type=template&id=cd2263e2&scoped=true&"
import script from "./BirthDatesInput.vue?vue&type=script&lang=ts&"
export * from "./BirthDatesInput.vue?vue&type=script&lang=ts&"
import style0 from "./BirthDatesInput.vue?vue&type=style&index=0&id=cd2263e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2263e2",
  null
  
)

export default component.exports